import {
  BriefcaseBusiness,
  CircleUserRound,
  Eye,
  FileCog,
  FilePlus2,
  Files,
  FolderKanban,
  Inbox,
} from "lucide-react";

export const employerNavigationSections = [
  {
    key: "funnel",
    label: "Hiring",
    items: [
      {
        href: "/dashboard/employer",
        label: "Deck",
        icon: BriefcaseBusiness,
        match: (location) => location.pathname === "/dashboard/employer",
      },
      {
        href: "/dashboard/stb/create",
        label: "Neue Anzeige",
        icon: FilePlus2,
        match: (location) => location.pathname === "/dashboard/stb/create",
      },
      {
        href: "/dashboard/stb/manage",
        label: "Verwalten",
        icon: FolderKanban,
        match: (location) => location.pathname === "/dashboard/stb/manage",
      },
      {
        href: "/dashboard/stb/applications",
        label: "Bewerbungen",
        icon: Inbox,
        match: (location) => location.pathname === "/dashboard/stb/applications",
      },
    ],
  },
  {
    key: "legacy",
    label: "Legacy",
    items: [
      {
        href: "/dashboard/stb/verwaltung",
        label: "Verwaltung",
        icon: Files,
        match: (location) => location.pathname === "/dashboard/stb/verwaltung",
      },
      {
        href: "/dashboard/stb/anzeigen",
        label: "Anzeigen",
        icon: Eye,
        match: (location) => location.pathname === "/dashboard/stb/anzeigen",
      },
      {
        href: "/dashboard/stb/edit/new",
        label: "Legacy Edit",
        icon: FileCog,
        match: (location) => location.pathname.startsWith("/dashboard/stb/edit/"),
      },
    ],
  },
  {
    key: "account",
    label: "Account",
    items: [
      {
        href: "/dashboard/account",
        label: "Konto",
        icon: CircleUserRound,
        match: (location) => location.pathname === "/dashboard/account",
      },
    ],
  },
];

export function flattenEmployerNavigationSections(sections = employerNavigationSections) {
  return sections.flatMap((section) => section.items || []);
}
